import { Box, Chip, Tooltip } from '@mui/material';
import {
  Datagrid,
  DateField,
  FunctionField,
  ReferenceField,
  TextField,
  usePermissions,
} from 'react-admin';
import { PERMISSIONS } from '../../constants';

export const ValueChip = ({ value, color }: { value: string | null; color: 'warning' | 'success' | 'default' }) => {
  if (value === null || value === undefined) {
    return <Chip label="(vazio)" size="small" variant="outlined" />;
  }
  const display = value.length > 40 ? value.slice(0, 40) + '…' : value;
  return (
    <Tooltip title={value}>
      <Chip label={display} size="small" color={color} />
    </Tooltip>
  );
};

interface ChangeLogDatagridProps {
  /** Exibe colunas de tipo e ID da entidade (usado na listagem global, não nas abas) */
  showEntityColumns?: boolean;
}

export const ChangeLogDatagrid = ({ showEntityColumns = false }: ChangeLogDatagridProps) => {
  const { permissions } = usePermissions();
  const canViewEmployee = permissions && permissions.includes(PERMISSIONS.UPDATE_USER);

  return (
    <Datagrid
      bulkActionButtons={false}
      sx={{ '& .RaDatagrid-rowCell': { paddingTop: 1, paddingBottom: 1 } }}
    >
      <DateField
        source="changedAt"
        label="Data/Hora"
        showTime
        locales="pt-BR"
        sx={{ minWidth: 150, whiteSpace: 'nowrap' }}
      />
      {showEntityColumns && (
        <FunctionField
          label="Tipo"
          render={(record: any) => (
            <Chip
              label={record.entityType === 'chain' ? 'Rede' : 'Posto'}
              size="small"
              variant="outlined"
            />
          )}
        />
      )}
      {showEntityColumns && <TextField source="entityId" label="ID da entidade" />}
      <TextField source="fieldName" label="Campo" />
      <FunctionField
        label="Valor anterior"
        render={(record: any) => <ValueChip value={record.oldValue} color="warning" />}
      />
      <FunctionField
        label="Novo valor"
        render={(record: any) => <ValueChip value={record.newValue} color="success" />}
      />
      <FunctionField
        label="Origem"
        render={(record: any) => {
          const labels: Record<string, string> = {
            'chain_edit': 'Edit Rede',
            'place_edit': 'Edit Posto',
            'chain_config': 'Settings',
            'partner_edit': 'Edit Parceiro',
          };
          return record.origin ? (
            <Chip label={labels[record.origin] ?? record.origin} size="small" variant="outlined" />
          ) : '—';
        }}
      />
      <ReferenceField
        source="changedById"
        reference="employees"
        label="Alterado por"
        link={canViewEmployee ? 'show' : false}
      >
        <TextField source="name" />
      </ReferenceField>
      <FunctionField
        label="Request ID"
        render={(record: any) =>
          record.requestId ? (
            <Tooltip title={record.requestId}>
              <Box component="span" sx={{ fontFamily: 'monospace', fontSize: 12, color: 'text.secondary' }}>
                {record.requestId.slice(0, 8)}…
              </Box>
            </Tooltip>
          ) : '—'
        }
      />
    </Datagrid>
  );
};
